import cn from 'classnames';

import { stripSpecialChars } from 'helpers';
import {
  setInlineBackgroundColor,
  setInlineTextAndBorderBottomColor,
  setInlineTextColor
} from 'helpers/LandingPageUtils';
import LandingPageImage from 'components/landing/LandingPageImage';
import LandingPageLink from 'components/landing/LandingPageLink';

import css from 'styles/components/landing/melodySplitEditorial.scss';

const MelodySplitEditorial = ({ slotName, slotIndex, slotDetails, onLandingComponentClick, shouldLazyLoad }) => {
  const { sections = [], monetateId } = slotDetails;

  // This checks to see if there are more than one content box. If so, this turns off
  // our overlay styling on mobile sized screens.
  let hasOneBox = false;
  const hasMultipleContentBoxes = sections.some(v => {
    if (v.heading || v.copy || v.cta || v.ctasecondary || v.brandsrc) {
      if (hasOneBox) {
        return true;
      } else {
        hasOneBox = true;
      }
    }
  });

  const makeContentContainer = (section, index) => {
    const { transparent, bgcolor, textcolor, heading, brandsrc, brandalt, brandretina, copy, subtext, ctalink, cta, ctasecondarylink, ctasecondary, ctagae, ctasecondarygae, full } = section;

    const hasContent = !!(heading || copy || cta || ctasecondary || brandsrc);

    const linkProps = {
      'onClick': onLandingComponentClick,
      'data-eventlabel': 'melodySplitEditorialLink1',
      'data-eventvalue': ctagae,
      'data-slotindex': slotIndex,
      'style': setInlineTextAndBorderBottomColor(textcolor)
    };

    const linkProps2 = {
      'onClick': onLandingComponentClick,
      'data-eventlabel': 'melodySplitEditorialLink2',
      'data-slotindex': slotIndex,
      'data-eventvalue': ctasecondarygae,
      'style': setInlineTextAndBorderBottomColor(textcolor)
    };

    const makeDivClasses = () => {
      let side;
      if (sections.length === 1 || full === 'true') {
        side = css.full;
      } else {
        side = (index === sections.length - 1) ? css.left : css.right;
      }
      return (
        cn(
          css.container,
          side,
          { [css.hasMultipleContentBoxes]: hasMultipleContentBoxes },
          { [css.transparent]: transparent === 'true' })
      );
    };

    return hasContent && (
      <div
        className={makeDivClasses()}
        style={setInlineBackgroundColor(bgcolor)}>
        {heading && <h2 style={setInlineTextColor(textcolor)}>{heading}</h2>}
        {brandsrc &&
          <LandingPageImage
            src={brandsrc}
            retina={brandretina}
            alt={brandalt}
            shouldLazyLoad={shouldLazyLoad}
          />}
        {copy && <p style={setInlineTextColor(textcolor)}>{copy}</p>}
        {subtext && <p className={css.subtext}>{subtext}</p>}
        {cta && <LandingPageLink url={ctalink} {...linkProps}>{cta}</LandingPageLink>}
        {ctasecondarylink && <LandingPageLink url={ctasecondarylink} {...linkProps2}>{ctasecondary}</LandingPageLink>}
      </div>
    );
  };

  return (
    <div className={css.splitEditorial} data-slot-id={slotName} data-monetate-id={monetateId}>
      {sections.map((section, i) => {
        const { src, mobilesrc, tabletsrc, retina, mobileretina, tabletretina, alt } = section;
        return (
          <div className={css.wrap} key={`${stripSpecialChars(src || mobilesrc || retina)}_${i}`}>
            <LandingPageImage
              src={src}
              mobilesrc={mobilesrc}
              tabletsrc={tabletsrc}
              retina={retina}
              mobileretina={mobileretina}
              tabletretina={tabletretina}
              alt={alt}
              shouldLazyLoad={shouldLazyLoad}
              className={i === 1 ? css.lazyImgRight : css.lazyImgLeft}
            />
            {makeContentContainer(section, i)}
          </div>
        );
      })}
    </div>
  );
};

export default MelodySplitEditorial;
